const education = [
    {
        degree: "M.S. in Artificial Intelligence | M.S.E. in Robotics Engineering",
        institution: "University of Michigan-Dearborn",
        years: "09/2024 - 12/2026",
        gpa: "3.9/4.0",
        transcriptLink: "/transcripts/umich_transcript.pdf",
        description: "Computer Vision concentration",
        courses: [
            "Deep Learning",
            "Robot Vision",
            "Mobile Robots",
            "Embedded Systems",
            "Pat. Rec. & Neural Networks",
            "Advanced AI",
        ],
    },
    {
        degree: "B.S. in Computer Science",
        institution: "Arizona State University",
        years: "08/2020 - 05/2024",
        gpa: "3.7/4.0",
        transcriptLink: "transcripts/ASU_FinalTranscript.pdf",
        description: "Certificate in Mathematical Concepts of Engineering",
        courses: [
            "Foundations of Machine Learning",
            "Applied Linear Algebra",
            "Data Visualization",
            "Exploring Data in R & Python",
            "Probability & Stats for Engr",
            "Intro to Theoretical CS",
        ],
    },
];

export default education;
